// src/utils/vidageFnct.ts — SCE Issues
// Vider les listes FNC-T avant d'importer la base corrigée (bascule, étape 2 —
// docs/chantier-fnct.md § 10 ; bouton demandé par Guillaume le 26/10). Les N°
// créés pendant l'essai existent aussi dans l'Excel : sans vidage, l'import
// complet les mélangerait. Pur, testable hors ligne.
//
// Avant toute suppression, une COPIE de tout (les trois listes, colonnes sous
// leur nom lisible) est déposée à côté des journaux d'import : c'est le filet.

/** Ce que contiennent les listes : une ligne = une FNC-T, une action, un événement. */
export interface ContenuListesFnct {
  fncts: number
  actions: number
  historique: number
}

export interface LigneSauvegardee {
  id: string
  fields: Record<string, unknown>
}

export interface SauvegardeFnct {
  version: 1
  /** Date de la sauvegarde (ISO). */
  le: string
  par: string
  /** Par nom de liste : SCE_FNCT, SCE_FNCT_Actions, SCE_FNCT_Historique. */
  listes: Record<string, LigneSauvegardee[]>
}

/** Mot à taper pour confirmer : un clic ne suffit pas pour tout effacer. */
export const MOT_CONFIRMATION_VIDAGE = 'VIDER'

export function confirmationVidageSaisie(saisie: string): boolean {
  return saisie.trim().toUpperCase() === MOT_CONFIRMATION_VIDAGE
}

export function totalContenu(c: ContenuListesFnct): number {
  return c.fncts + c.actions + c.historique
}

/** « 278 FNC-T, 770 actions et 1 204 événements d'historique » ; « Les listes sont vides. » à zéro. */
export function resumeContenu(c: ContenuListesFnct): string {
  if (totalContenu(c) === 0) return 'Les listes sont vides.'
  const nombre = (n: number): string => n.toLocaleString('fr-FR')
  const morceaux = [
    `${nombre(c.fncts)} FNC-T`,
    `${nombre(c.actions)} action${c.actions > 1 ? 's' : ''}`,
    `${nombre(c.historique)} événement${c.historique > 1 ? 's' : ''} d’historique`,
  ]
  return `${morceaux.slice(0, -1).join(', ')} et ${morceaux.at(-1)}`
}

/** `Sauvegarde avant vidage 2026-10-26 14h05.json` (heure de Paris). */
export function nomSauvegarde(le: Date): string {
  const p = new Intl.DateTimeFormat('fr-CA', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(le)
  const v = (t: string): string => p.find((x) => x.type === t)?.value ?? ''
  return `Sauvegarde avant vidage ${v('year')}-${v('month')}-${v('day')} ${v('hour')}h${v('minute')}.json`
}
